import type { CNestedCatalogsTranslations } from "./pl";

export const en: CNestedCatalogsTranslations = {
  emptyData: "No data to display.",
  emptyList: "No information in this section.",
};
